import { AlertType, UniAlert } from '@/design-system/components/alerts';
import { UniButton } from '@/design-system/components/buttons';
import { getObjectScreenNameFromPath, popStateLockedMap } from '@/design-system/components/navigatorEmbed/UtxAppNavigatorEmbed';
import { UniTabHeader } from '@/design-system/components/tabs';
import { useBottomsheet } from '@/devtools/screens_deprecated/useBottomsheet.hook';
import { useFocusEffect, useIsFocused, useNavigation } from '@react-navigation/native';
import { ScrollView, SxProp, View } from 'dripsy';
import * as DocumentPicker from 'expo-document-picker';
import _ from 'lodash';
import React, { useCallback, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Platform } from 'react-native';
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import { useStore } from 'store/store';
import { RootStackRoutes } from 'types';
import BillPaymentApp from '../..';
import { QuoteResponse, UseCreateBillPaymentProp } from '../../hooks/useCreateBillPayment.hook';
import { BillPaymentConfirmProp, BillPaymentStackRoutes } from '../../payment.navigator';
import { mapUrlLink, onGoBack } from '../../utils/utils';
import { ConfirmFormBillPayment } from '../components/ConfirmFormBillPayment.bottomsheet';
import { ConfirmGoogleOtp } from '../components/ConfirmGoogleOtp.bottomsheet';
import { ConfirmSmsOtp } from '../components/ConfirmSmsOtp.bottomsheet';
import { HeaderBackgroundImageComponent } from '../components/HeaderBackgroundImageComponent';
import { UploadMobileComponent } from './UploadMobile.component';
export interface BillPaymentInstructionNativeProps {
  documentCallback: (file: DocumentPicker.DocumentResult) => void;
  useCreateBillPayment: UseCreateBillPaymentProp;
  emailComponent: JSX.Element;
}

export const BillPaymentInstructionMobileComponent: React.FC<BillPaymentInstructionNativeProps> = ({
  documentCallback,
  useCreateBillPayment,
  emailComponent
}) => {
  const { t } = useTranslation('global-bill-payment');
  const navigation = useNavigation();
  const insets = useSafeAreaInsets();
  const createBillPayment = useCreateBillPayment;
  const {
    general: { alertMessage },
    instruction: { statusButtonQuote, setStatusButtonQuote, isLoadingUpload, isSuccessUpload, mapQuoteDataRequest, resetQuote, postQuote },
    postCreateBillPayment: { nextParamProp }
  } = createBillPayment;
  const { bottomsheetRef, onOpen, onClose } = useBottomsheet();
  const { bottomsheetRef: bottomSheetOTPRef, onOpen: onOpenOTP, onClose: onCloseOTP } = useBottomsheet();
  const [dataResult, setDataResult] = useState<BillPaymentConfirmProp>();
  const [debitAccount, setDebitAccount] = useState<string>('');
  const [userFee, setUserFee] = useState<string>('');
  const isFocused = useIsFocused();
  const store = useStore();
  const [initOTP, setInitOTP] = useState(false);

  const debitAccountCallback = (input: string) => {
    setDebitAccount(input);
    if (!!dataResult && !!input) setDataResult({ ...dataResult, debitAccount: input });
  };

  const setUserFeeCallBank = (input: string) => {
    setUserFee(input);
  };

  useEffect(() => {
    if (!!nextParamProp && !!nextParamProp.request && nextParamProp.response) {
      if (statusButtonQuote) {
        if (!!nextParamProp.response && nextParamProp.response.classified) {
          postQuote(
            mapQuoteDataRequest(nextParamProp.request, nextParamProp.response),
            (data) => {
              const response: QuoteResponse = data.data;
              setDataResult({
                request: mapQuoteDataRequest(nextParamProp.request, response),
                response: nextParamProp.response,
                flagUploaded: false,
                debitAccount: debitAccount,
                documentSelected: createBillPayment.instruction.documentSelected,
                paymentType: createBillPayment.general.paymentType!
              });
              setTimeout(() => {
                onOpen();
              }, 400);
            },
            (error) => {
              console.log(error);
              navigation.navigate(RootStackRoutes.BillPayment, {
                screen: BillPaymentStackRoutes.Form,
                params: nextParamProp
              });
            }
          );
        } else {
          navigation.navigate(RootStackRoutes.BillPayment, {
            screen: BillPaymentStackRoutes.Form,
            params: nextParamProp
          });
        }
        setStatusButtonQuote(false);
      }
    }
  }, [nextParamProp, statusButtonQuote]);

  const onResultConfirm = () => {
    onClose();
    setInitOTP(true);
    setTimeout(() => {
      onOpenOTP();
    }, 500);
  };

  const OTPBottomSheet = () => {
    if (initOTP && !!dataResult) {
      if (store.users && store.users.tfaKeyStatus)
        return (
          <ConfirmGoogleOtp
            bottomsheetRef={bottomSheetOTPRef}
            onClose={onCloseOTP}
            dataProp={dataResult}
            userFee={userFee}
            documentSelected={createBillPayment.instruction.documentSelected}
          />
        );
      else
        return (
          <ConfirmSmsOtp
            bottomsheetRef={bottomSheetOTPRef}
            onClose={onCloseOTP}
            dataProp={dataResult}
            userFee={userFee}
            documentSelected={createBillPayment.instruction.documentSelected}
          />
        );
    }
    return <></>;
  };

  const onBack = () => {
    if (Platform.OS === 'web') {
      popStateLockedMap.set('popstate', true);
      onGoBack(navigation);
      setTimeout(() => popStateLockedMap.set('popstate', false), 500);
    } else {
      onGoBack(navigation);
    }
  };

  const onPopState = (event: any) => {
    window.history.pushState(event.state, '');
    setTimeout(() => {
      const popStateLocked = popStateLockedMap.get('popstate') ?? false;
      if (!document.location.href || popStateLocked) return;
      const { parentName, subName } = mapUrlLink(document.location.href);
      var screenNameObject = getObjectScreenNameFromPath([BillPaymentApp], `/${subName}`);
      if (
        screenNameObject.screenName &&
        screenNameObject.routeStackName === parentName &&
        screenNameObject.screenName !== BillPaymentStackRoutes.Landing
      ) {
        onBack();
      }
    }, 200);
  };

  useFocusEffect(
    useCallback(() => {
      if (Platform.OS === 'web') {
        window.addEventListener('popstate', onPopState);
        return () => {
          window.removeEventListener('popstate', onPopState);
        };
      }
    }, [])
  );

  return (
    <View sx={sxStyles.container}>
      <View sx={{ ...sxStyles.header, ...{ pt: insets.top } }}>
        <HeaderBackgroundImageComponent />
        <UniTabHeader
          title={t('global-bill-payment::glossary.title--payment-instruction')}
          showBackButton={navigation.canGoBack()}
          onBack={() => onBack()}
          labelColor="$white"
          sx={sxStyles.tab}
        />
      </View>
      <ScrollView sx={sxStyles.scrollViewWrapper} contentContainerStyle={{ flexGrow: 1 }} showsVerticalScrollIndicator={false}>
        <View sx={sxStyles.body}>
          <UploadMobileComponent documentCallback={documentCallback} />
          {!_.isEmpty(alertMessage) && <UniAlert type={AlertType.Error} message={alertMessage} sx={sxStyles.viewAlert} />}
          {isSuccessUpload && !isLoadingUpload && (
            <UniButton
              label={t('global-bill-payment::glossary.continue')}
              onPress={async () => {
                resetQuote();
              }}
              sx={sxStyles.button}
              size="medium"
              loading={statusButtonQuote}
              disabled={statusButtonQuote}
            />
          )}
          {emailComponent}
        </View>
      </ScrollView>
      {isFocused && !!dataResult && (
        <>
          <ConfirmFormBillPayment
            bottomsheetRef={bottomsheetRef}
            onClose={onClose}
            dataProp={dataResult}
            onResult={onResultConfirm}
            debitAccountCallback={debitAccountCallback}
            setUserFeeCallBank={setUserFeeCallBank}
          />
          {OTPBottomSheet()}
        </>
      )}
    </View>
  );
};

const sxStyles: Record<string, SxProp> = {
  container: {
    backgroundColor: '$backgroundPrimary',
    width: '100%',
    height: '100%'
  },
  header: {
    flexDirection: 'column'
  },
  tab: {
    backgroundColor: 'transparent',
    width: '98%'
  },
  body: {
    flex: 1,
    zIndex: 10
  },
  button: {
    width: '100%',
    height: '$11',
    mt: '$5'
  },
  scrollViewWrapper: {
    pt: '$5',
    pb: '$10',
    px: '$4'
  },
  viewAlert: {
    mt: '$5'
  }
};
